import * as React from 'react';
import { useSelector } from 'react-redux';

import { getQuestionById } from '../../../selectors/questions';
import { CommentPart, Comment } from '../../../components/Comment';

interface IQuestionContainerProps {
  questionId: string;
}

export function QuestionContainer({ questionId }: IQuestionContainerProps): React.JSX.Element {
  const { comment } = useSelector(getQuestionById(questionId));

  return (
    <Comment>
      <CommentPart message={comment.legacy} />
    </Comment>
  );
}
